import { getExperiments as getExperimentsApi, IExperiment } from '../api/experiments';
import { ALLOW_SUBDOMAINS_MICRODATA, MICRODATA_EXPERIMENT } from '../utils/microdata_experiment';
import { IThunkActionCreator } from './index';

export interface IExperimentsFetched {
  type: 'IExperimentsFetched';
  experiments: IExperiment[];
}

export function getExperiments(
  pythonApiBaseUrl: string,
  cookies: string | undefined,
  experiments: string[],
  subdomain: string,
): IThunkActionCreator {
  return (dispatch, getState, context) => {
    return getExperimentsApi(context.makeRequest, pythonApiBaseUrl, cookies, experiments)
    .catch((error: Error) => {
      context.logger.error(error, { details: 'Failed to get experiments' });

      return [];
    })
    // tslint:disable-next-line:variable-name
    .then((_experiments) => {
      const microdataExperimentsData = {
        abGroup: ALLOW_SUBDOMAINS_MICRODATA.includes(subdomain) ? 1 : 0,
        name: MICRODATA_EXPERIMENT,
      };

      dispatch<IExperimentsFetched>({
        experiments: [..._experiments, microdataExperimentsData],
        type: 'IExperimentsFetched',
      });

      return _experiments;
    });
  };
}

export function experimentsReducer(
  state: IExperiment[],
  action: IExperimentsFetched,
): IExperiment[] {
  switch (action.type) {
    case 'IExperimentsFetched':
      return [...action.experiments];

    default:
      return state || [];
  }
}
